module.exports = __webpack_public_path__ + "img/cart-intro.dc4c56a8.jpg";